// extracted by mini-css-extract-plugin
module.exports =  {"radio":"_0d624b9a27--radio--p_Jis","label":"_0d624b9a27--label--NuGL4","indicator":"_0d624b9a27--indicator--Xzm1l","hasLabel":"_0d624b9a27--hasLabel--FrIXx"};